import React from "react";
import cn from 'classnames';
import st from './category.module.scss'
import { useWideScreen } from "@hooks/useWideScreen";
import { formatNumberIntl } from "@utils/format/number";
import PercentCircle from "@modules/dashboards/percentCircle/PercentCircle";
import { ExpensesDetalizationData } from "../../../../../store/reducers/dashboard/expenses/detalization";
import Badge from "@pages/dashboard/expenses/components/badge/Badge";


interface CategoryProps {
    category: ExpensesDetalizationData,
    isActive: boolean,
    percent: number,
    onSelect: (categoryTitle: string) => void,
    isEmptyData?: boolean
}

const Category = (props: CategoryProps) => {
    const { category, isActive, percent, isEmptyData } = props;

    const isWideScreen = useWideScreen()

    return (
        <div
            onClick={() => !isEmptyData && props.onSelect(category.title)}
            className={cn(
                st.category,
                !isEmptyData && isActive && st.active
            )}
            style={{
                // backgroundColor: category.bgColor,
                // color: category.color
            }}
        >
            <div className={st.info}>
                <Badge category={category}/>
                <div className={st.fact}>{!isEmptyData ? formatNumberIntl(category.totalFact) + ' руб' : 'Нет данных'}</div>
            </div>
            <div className={st.diagram}>
                <PercentCircle
                    percent={percent}
                    size={isWideScreen ? 'huge' : 'large'}
                    bgColor={category.chartBg}
                    color={category.chartBg}
                />
            </div>

        </div>
    )
}


export default Category;